/**
 * @generated SignedSource<<94e06ffc943141abb9a136676feb88bc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsFaqSidebar_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsYourFirm_viewer">;
  readonly " $fragmentType": "TradeBenefitsFaqSidebar_viewer";
};
export type TradeBenefitsFaqSidebar_viewer$key = {
  readonly " $data"?: TradeBenefitsFaqSidebar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsFaqSidebar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsFaqSidebar_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsYourFirm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4180c1e1fc2f6748424f6fd23ec76cb0";

export default node;
